import { render, staticRenderFns } from "./host-common-tip.vue?vue&type=template&id=ef453cbe&scoped=true&"
import script from "./host-common-tip.vue?vue&type=script&lang=js&"
export * from "./host-common-tip.vue?vue&type=script&lang=js&"
import style0 from "./host-common-tip.vue?vue&type=style&index=0&id=ef453cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef453cbe",
  null
  
)

export default component.exports